import {VehicleIdentifierValidator} from "../validation/VehicleIdentifierValidator";
import {IVumFlattenedVehicle} from "../vum/VumFlattenedVehicleConverter";

export class VehicleImageUrlBuilder {
    private readonly vehicleImageEndpoint: string;
    private readonly fallbackViewDirection = 'side';
    private readonly fallbackAngle = 'right';
    private readonly volkswagenIdentifier = 'volkswagen';
    private readonly commercialVehiclesIdentifier = 'commercialVehicles';

    constructor(private readonly customConfig: any) {
        this.vehicleImageEndpoint = 'vehicleimages/exterior/'
    }

    public getUrlForImageRequestWithDefaultView(vehicle: IVumFlattenedVehicle): string {
        let viewDirection;
        let angle;
        try {
            if (VehicleIdentifierValidator.isCommercialVehicleVin(vehicle.vin)) {
                viewDirection = this.customConfig.defaultViews[this.commercialVehiclesIdentifier].viewDirection;
                angle = this.customConfig.defaultViews[this.commercialVehiclesIdentifier].angle;
            } else {
                viewDirection = this.customConfig.defaultViews[this.volkswagenIdentifier].viewDirection;
                angle = this.customConfig.defaultViews[this.volkswagenIdentifier].angle;
            }
        } catch (e) {
            viewDirection = this.fallbackViewDirection;
            angle = this.fallbackAngle;
        }

        return this.vehicleImageEndpoint + this.getVehicleUrlParams(vehicle) + `?viewDirection=${viewDirection}&angle=${angle}`;
    }

    private getVehicleUrlParams(vehicle: IVumFlattenedVehicle): string {
        return !vehicle.vin ?
            vehicle.commissionNumber + '/' + vehicle.bid + '/' + vehicle.commissionNumberYear : vehicle.vin;
    }
}
